<template>
  <div>
    <PageHeader :schema="$schemas.invoiceSetting" />
    <PageContent>
      <DynamicFormPage
        :schema="$schemas.invoiceSetting"
        :service="$api.invoiceSettings"
      />
    </PageContent>
  </div>
</template>

<script>
import PageHeader from '@/components/PageHeader';
import PageContent from '@/components/PageContent';
import DynamicFormPage from '@/components/dynamics/DynamicFormPage';

export default {
  name: 'CreateInvoiceSetting',
  components: { PageHeader, PageContent, DynamicFormPage },
};
</script>
